document.addEventListener('DOMContentLoaded', () => {
  const stickyBuyBar = document.querySelector('.sticky-buy');
  const buttonSection = document.querySelector('.single-product__buttons');
  const stickyBuyImage = stickyBuyBar?.querySelector('.sticky-buy__image');
  const productTitle = document.querySelector('.single-product__title');
  if (!stickyBuyBar || !buttonSection || !stickyBuyImage || !productTitle) {
    return;
  }

  /** Disable/enable tabbing on any buttons/links in the stucky buy bar */
  const toggleButtonTabbing = (allowTabbing: boolean) => {
    stickyBuyBar.querySelectorAll('button, a').forEach((el) => {
      const tabindex = allowTabbing ? '0' : '-1';
      el.setAttribute('tabindex', tabindex);
    });
  };

  // Disable tabbing initially since the bar is hidden
  toggleButtonTabbing(false);

  /**
   * Keep track of if the title and buttons are visible,
   * so we can show the sticky buy bar when both are offscreen
   */
  const elementVisibility = {
    title: false,
    buttons: false,
  };

  /**
   * Add intersection observer to watch for when the user scrolls past the trigger point (button section),
   * then show/hide the sticky buy bar accordingly
   */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const whichElement = entry.target.classList.contains('single-product__buttons')
        ? 'buttons'
        : 'title';
      // Update the visibility object based on whether the element is intersecting
      elementVisibility[whichElement] = entry.isIntersecting;

      // Check if both elements are offscreen
      if (Object.values(elementVisibility).every((visible) => !visible)) {
        stickyBuyBar.classList.add('sticky-buy--visible');
        stickyBuyBar.setAttribute('aria-hidden', 'false');
        toggleButtonTabbing(true);
      } else {
        stickyBuyBar.classList.remove('sticky-buy--visible');
        stickyBuyBar.setAttribute('aria-hidden', 'true');
        toggleButtonTabbing(false);
      }
    });
  });
  observer.observe(buttonSection);
  observer.observe(productTitle);

  // Listen to the custom event to update the sticky buy image
  // This is emitted in gallery.ts, when the flickity gallery changes slide
  document.addEventListener('product:image-change', (event: CustomEvent) => {
    const { image } = event.detail;
    // console.debug('Product image has changed', image);
    // Setting data-src as well so it doesn't replace with placeholder on initial load
    stickyBuyImage.setAttribute('data-src', image);
    stickyBuyImage.setAttribute('src', image);
  });
});
